<template>
  <div class="ssjk">
    <template>
       <h4 style="color: aliceblue;margin-top: -30px">
         实时监控
       </h4>
     </template>
    <div class="u-myflex">
      <div style="min-height: 8.1rem" class="u-flex-1 u-myflex u-flexwrap video-div">
        <div id="video0" :style="{'width':width }">
          <div class="test-ellipsis video-title">窗口1</div>
          <div style="padding: 4px; text-align: center; flex: 1">
<!--            <video-ws-stream
              class="my-video"
              v-if="camera1.streamUrl || tempOpen"
              :data="camera1"
            ></video-ws-stream> -->
            <assembly-flv v-if="camera0.streamUrl"  :url="camera0.streamUrl" :style="{ 'height': height + 'px','width':width }"></assembly-flv>
            <div
              v-else
              style="height: 100%; width: 100%"
              class="u-text-center u-m5-t-10 u-tips-color"
            >
              <div>
                <i
                  style="font-size: 0.6rem"
                  class="el-icon-document-delete u-text-center"
                ></i>
              </div>
              <span class="u-font-weight">无法连接相关设备</span>
            </div>
            <div :style="{'width':width }" v-if="camera0.devicename">当前设备:{{camera0.devicename || '未命名设备'}}</div>
          </div>
        </div>
        <div id="video1" v-if="!width">
          <div class="test-ellipsis video-title">窗口2</div>
          <div style="padding: 4px; text-align: center; flex: 1">
            <!-- <video-ws-stream
              class="my-video"
              v-if="camera2.streamUrl || tempOpen"
              :data="camera2"
            ></video-ws-stream> -->
            <assembly-flv v-if="camera1.streamUrl" height="300px" :url="camera1.streamUrl" ></assembly-flv>
            <div
              v-else
              style="height: 100%; width: 100%"
              class="u-text-center u-m5-t-10 u-tips-color"
            >
              <div>
                <i
                  style="font-size: 0.6rem"
                  class="el-icon-document-delete u-text-center"
                ></i>
              </div>
              <span class="u-font-weight">无法连接相关设备</span>
            </div>
            <div style="width: 100%;" v-if="camera1.devicename">当前设备:{{camera1.devicename || '未命名设备'}}</div>
          </div>
        </div>
        <div id="video2" v-if="!width">
          <div class="test-ellipsis video-title">窗口3</div>
          <div style="padding: 4px; text-align: center; flex: 1">
            <!-- <video-ws-stream
              class="my-video"
              v-if="camera3.streamUrl || tempOpen"
              :data="camera3"
            ></video-ws-stream> -->
            <assembly-flv v-if="camera2.streamUrl" height="300px" :url="camera2.streamUrl" ></assembly-flv>
            <div
              v-else
              style="height: 100%; width: 100%"
              class="u-text-center u-m5-t-10 u-tips-color"
            >
              <div>
                <i
                  style="font-size: 0.6rem"
                  class="el-icon-document-delete u-text-center"
                ></i>
              </div>
              <span class="u-font-weight">无法连接相关设备</span>
            </div>
            <div style="width: 100%;" v-if="camera2.devicename">当前设备:{{camera2.devicename || '未命名设备'}}</div>
          </div>
        </div>
        <div id="video3" v-if="!width">
          <div class="test-ellipsis video-title">窗口4</div>
          <div style="padding: 4px; text-align: center; flex: 1">
            <!-- <video-ws-stream
              class="my-video"
              v-if="camera4.streamUrl || tempOpen"
              :data="camera4"
            ></video-ws-stream> -->
            <assembly-flv v-if="camera3.streamUrl" height="300px" :url="camera3.streamUrl" ></assembly-flv>
            <div
              v-else
              style="height: 100%; width: 100%"
              class="u-text-center u-m5-t-10 u-tips-color"
            >
              <div>
                <i
                  style="font-size: 0.6rem"
                  class="el-icon-document-delete u-text-center"
                ></i>
              </div>
              <span class="u-font-weight">无法连接相关设备</span>
            </div>
            <div style="width: 100%;" v-if="camera3.devicename">当前设备:{{camera3.devicename || '未命名设备'}}</div>
          </div>
        </div>
        <div id="video4" v-if="!width && optionNum == 6">
          <div class="test-ellipsis video-title">窗口5</div>
          <div style="padding: 4px; text-align: center; flex: 1">
            <!-- <video-ws-stream
              class="my-video"
              v-if="camera4.streamUrl || tempOpen"
              :data="camera4"
            ></video-ws-stream> -->
            <assembly-flv v-if="camera4.streamUrl" height="300px" :url="camera4.streamUrl" ></assembly-flv>
            <div
              v-else
              style="height: 100%; width: 100%"
              class="u-text-center u-m5-t-10 u-tips-color"
            >
              <div>
                <i
                  style="font-size: 0.6rem"
                  class="el-icon-document-delete u-text-center"
                ></i>
              </div>
              <span class="u-font-weight">无法连接相关设备</span>
            </div>
            <div style="width: 100%;" v-if="camera4.devicename">当前设备:{{camera4.devicename || '未命名设备'}}</div>
          </div>
        </div>
        <div id="video5" v-if="!width && optionNum == 6">
          <div class="test-ellipsis video-title">窗口6</div>
          <div style="padding: 4px; text-align: center; flex: 1">
            <!-- <video-ws-stream
              class="my-video"
              v-if="camera4.streamUrl || tempOpen"
              :data="camera4"
            ></video-ws-stream> -->
            <assembly-flv v-if="camera5.streamUrl" height="300px" :url="camera5.streamUrl" ></assembly-flv>
            <div
              v-else
              style="height: 100%; width: 100%"
              class="u-text-center u-m5-t-10 u-tips-color"
            >
              <div>
                <i
                  style="font-size: 0.6rem"
                  class="el-icon-document-delete u-text-center"
                ></i>
              </div>
              <span class="u-font-weight">无法连接相关设备</span>
            </div>
            <div style="width: 100%;" v-if="camera5.devicename">当前设备:{{camera5.devicename || '未命名设备'}}</div>
          </div>
        </div>
        <p style="float:left; margin-top:10px;margin-bottom: 10px;">分屏窗口数: <el-button  type="primary" size='mini' @click="oneVideo">1</el-button>
                 <el-button  type="primary" size='mini' @click="fourVideo">4</el-button>
                 <el-button  type="primary" size='mini' @click="sixVideo">6</el-button>
                 <el-button  type="primary" size='mini' icon="el-icon-tickets" @click="listStatus">{{liststatus}}</el-button>
        </p>
      </div>
      <div class="video-list u-position-relative" v-if="!showlist">
        <el-table :data="mp4Path" stripe class="u-flex-3">
          <el-table-column label="实时播放">
            <template slot-scope="scope">
              <div class="u-myflex u-j-sb u-a-center">
                <el-tooltip
                  :disabled="scope.row.path.length < 18"
                  :content="scope.row.path"
                  placement="top"
                  effect="light"
                >
                  <a
                    href="javascript:;"
                    @click="changeSelect(0, scope.row.value)"
                    style="margin-left: 10px"
                    :class="[
                      'u-line-1',
                      scope.row.value == videoBtnId ? 'u-color-primary' : 'u-color-dark',
                    ]"
                    >{{ scope.row.path }}</a
                  >
                </el-tooltip>

                <el-select
                  @change="(index) => changeSelect(index, scope.row.value)"
                  style="width: 100px"
                  v-model="mp4Path[scope.row.value].videoValue"
                  placeholder="请选择"
                  :key="selectKey"
                  size="mini"
                  v-if="videoNum"
                >
                  <el-option
                    v-for="item in scope.row.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="u-position-absolute u-t-20 u-r-0">
          <el-pagination
            @current-change="clickPage"
            layout="total,prev, pager, next"
            :total="total"
            :pager-count="5"
            :page-size="13"
          >
          </el-pagination>
        </div>

        <!-- 通道列表 -->
        <el-table :data="mp4PathSuffix" stripe class="u-flex-2" :key="refreKey2" v-if="channelOpen">
          <el-table-column label="通道列表">
            <template slot-scope="scope">
              <div class="u-myflex u-j-sb u-a-center">
                <el-tooltip
                  :disabled="scope.row.path.length < 10"
                  :content="scope.row.path"
                  placement="top"
                  effect="light"
                >
                  <a
                    href="javascript:;"
                    @click="historyvideoSet(scope.row)"
                    style="margin-left: 10px"
                    :class="[
                      'u-line-1',
                      scope.row.value == videoBtn_history ? 'u-color-primary' : '',
                    ]"
                    >{{ scope.row.path }}</a
                  >
                </el-tooltip>

                <el-select
                  @change="(index) => openVideo(scope.row.deviceId,scope.row.path,index)"
                  style="width: 100px"
                  v-model="mp4PathSuffix[scope.row.value].videoValue"
                  placeholder="请选择"
                  :key="selectKey"
                  size="mini"
                >
                  <el-option
                    v-for="item in scope.row.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>


    </div>
  </div>
</template>

<script>
import videoWsStream from "@/components/video-ws-stream.vue";
import config from "@/web.config.js";
import assemblyFlv from "@/components/assembly-flv.vue";
export default {
  components: { videoWsStream ,"assembly-flv": assemblyFlv},
  data() {
    return {
      headers:{'Content-Type':'application/x-www-form-urlencoded'},
      tempOpen: config.tempOpen,
      showlist:false,
      liststatus:"隐藏列表",
      total: 0,
      refreKey: "y",
      width:"",
      height:300,
      devicename:"",
      channelOpen:false,
      videoNum:true,
      camera0: {streamUrl:"",deviceId:"",channelId:""},
      camera1: {streamUrl:"",deviceId:"",channelId:""},
      camera2: {streamUrl:"",deviceId:"",channelId:""},
      camera3: {streamUrl:"",deviceId:"",channelId:""},
      camera4: {streamUrl:"",deviceId:"",channelId:""},
      camera5: {streamUrl:"",deviceId:"",channelId:""},
      streamRequestSeq: [0, 0, 0, 0, 0, 0],
      deviceList: [],
      baseUrl: config.cameraUrl,
      deviceListForm: {
        deviceType: "4",
        pageIndex: 1, //经常改，也不知道用哪个字段
        page: 1, //经常改，也不知道用哪个字段
        pageRow: 13,
        limit: 13,
      },
      label: "",
      selectKey: "s",
      refreKey2: "c",
      videoBtn_history: "",
      videoValue: "",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
        },
      ],
      videoAutoplay: false, //设置视频是否自动播放
      mp4Path: [
        // { path: "东城翠峰路中段公交站", value: 0 },
      ],
      optionNum: 4,
      mp4PathSuffix: [],
      mp4PathSuffix_index: [],
      // mp4PathSuffix_0: [
      //   { path: '2022-04-24', value: 0 },
      //   { path: '2022-04-25', value: 1 },
      //   { path: '2022-04-26', value: 2 }
      // ],
      // mp4PathSuffix_1: [
      //   { path: '2022-03-22', value: 0 },
      //   { path: '2022-01-25', value: 1 },
      //   { path: '2022-01-20', value: 2 }
      // ],
      // mp4PathSuffix_2: [
      //   { path: '2022-04-04', value: 0 },
      //   { path: '2022-04-15', value: 1 },
      //   { path: '2022-02-06', value: 2 }
      // ],
      // mp4PathSuffix_3: [
      //   { path: '2022-03-21', value: 0 },
      //   { path: '2022-04-15', value: 1 },
      //   { path: '2022-01-21', value: 2 }
      // ],
      videoBtnId: null, //用来保存展开了按钮的列表项
      historyShow: false, //历史播放列表显隐
      videoPlay: [], //保存哪个摄像头在播放
      pathHistory: "",
      save_selectKey: [],
    };
  },
  computed: {
    realTitle(name) {
      return function (name) {
        let str = name + "--";
        let num = this.videoPlay.indexOf(name);
        let str1 = num > -1 ? `窗口${num + 1}` : "无";
        return str + str1;
      };
    },
  },
  methods: {
    clickPage(index) {
      this.deviceListForm.pageIndex = this.deviceListForm.page = index;
      this.getDeviceList(this.optionNum);
    },
    getDeviceList(num) {
      this.mp4Path = [];
        this.$axios({
        	method: 'get',
        	url: this.baseUrl+'/api/device/query/devices?page='+this.deviceListForm.page+'&count=13',
        	timeout: 30000,
        	}).then(res=>{
            if (res.data) {
              if (!this.total) this.total = res.data.total;
              let optionNum = [];
              if(num == 4){
                optionNum = [{value: "0",label: "窗口1",},{value: "1",label: "窗口2",},{value: "2",label: "窗口3",},{value: "3",label: "窗口4",}]
              }
              if(num == 6){
                optionNum = [{value: "0",label: "窗口1",},{value: "1",label: "窗口2",},{value: "2",label: "窗口3",},{value: "3",label: "窗口4",},{value: "4",label: "窗口5",},{value: "5",label: "窗口6",}]
              }
              res.data.list.forEach((element, key) => {
                this.mp4Path.push({
                  ...element,
                  path: element.name || '未命名设备',
                  deviceId: element.deviceId,
                  online:element.online,
                  value: key,
                  videoValue: "",
                  options: optionNum
                });
              });
            }
        	})

    },
    changeSelect(index, mp4PthIndex) {
      // const save_index = this.save_selectKey.indexOf(index);
      // if (save_index > -1) {
      //   if (this.mp4Path[save_index].videoValue > -1) {
      //     this.videoSet(save_index, null,null);
      //   }
      //   this.save_selectKey[save_index] = -1;
      //   this.mp4Path[save_index].videoValue = "";
      // }

      //this.save_selectKey[mp4PthIndex] = index;
      //this.selectKey = "s" + new Date().getTime();
      this.videoSet(index, this.mp4Path[mp4PthIndex].path,this.mp4Path[mp4PthIndex].deviceId);
    },
    oneVideo(){
      this.height = 600;
      this.width = "100%";
      this.videoNum = false;
    },
    fourVideo(){
      this.height = 300;
      this.width = "";
      this.videoNum = true;
      this.optionNum = 4;
      this.getDeviceList(4);
    },
    sixVideo(){
      this.height = 300;
      this.width = "";
      this.videoNum = true;
      this.optionNum = 6;
      this.getDeviceList(6);
      if(this.camera4.streamUrl == ""){
        setTimeout(() => {
          if(this.mp4Path[4].deviceId != null)
          this.getChannelid(this.mp4Path[4].deviceId,4,this.mp4Path[4].name);
        }, 1000);
      }
      if(this.camera5.streamUrl == ""){
        setTimeout(() => {
          if(this.mp4Path[5].deviceId != null)
          this.getChannelid(this.mp4Path[5].deviceId,5,this.mp4Path[5].name);
        }, 2000);
      }
    },
    listStatus(){
      this.showlist = !this.showlist
      if(this.showlist){
        this.liststatus = "展示列表"
      }else{
        this.liststatus = "隐藏列表"
      }
    },
    showVideoBtn(index, path ,deviceId) {
      if (this.videoBtnId == index) {
        this.videoBtnId = null;

      } else if (this.videoBtnId !== index && this.videoBtnId == null) {
        this.videoBtnId = index;

      } else {
        this.videoBtnId = index;

      }
      this.label = path;
      this.devicename = path;
      this.mp4PathSuffix_index = [];
      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/device/query/devices/'+deviceId+'/channels?page=1&count=15',
      	timeout: 30000,
      	}).then(res=>{
        if (res.data) {
          if (!this.total) this.total = res.data.total;
          this.channelId = res.data.list[0].channelId;
          // res.data.list.forEach((element, key) => {
          //   this.mp4PathSuffix_index.push({
          //     path: element.channelId,
          //     value: key,
          //     deviceId: deviceId
          //   });
          // });
          this.mp4PathSuffix_index.push({
              path: res.data.list[0].channelId,
              value: 0,
              deviceId: deviceId
            });
          let list = this.mp4PathSuffix_index.map((item, key) => {
          //let list = this["mp4PathSuffix_" + index].map((item, key) => {
            item.options = [
              {
                value: "0",
                label: "窗口1",
              },
              {
                value: "1",
                label: "窗口2",
              },
              {
                value: "2",
                label: "窗口3",
              },
              {
                value: "3",
                label: "窗口4",
              },
            ];
            return item;
          });
          this.$set(this, "mp4PathSuffix", list);
          this.refreKey2 = "c" + new Date().getTime();
        }
      });
    },

    videoSet(index, name,deviceId, set = true) {
      this.save_selectKey.push(index);
      this.getChannelid(deviceId,index,name);
      if (set) {
        this.$set(this.videoPlay, index, name);
      } else {
        this.$set(this.videoPlay, index, this.pathHistory);
      }
    },
    nextStreamRequest(index) {
      const requestId = (this.streamRequestSeq[index] || 0) + 1;
      this.$set(this.streamRequestSeq, index, requestId);
      return requestId;
    },
    isCurrentStreamRequest(index, requestId, deviceId, channelId) {
      const camera = this["camera" + index];
      return this.streamRequestSeq[index] === requestId
        && camera.deviceId === deviceId
        && (channelId === undefined || camera.channelId === channelId);
    },
    openVideo(deviceId,channelId,index,requestId,devicename){
      const activeRequestId = requestId === undefined ? this.nextStreamRequest(index) : requestId;
      const camera = this["camera" + index];
      if (!this.isCurrentStreamRequest(index, activeRequestId, deviceId, channelId)) {
        return;
      }
      camera.streamUrl = "";
      camera.devicename = devicename;
      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/play/start/'+deviceId+'/'+channelId,
      	//headers:this.headers,
      	timeout: 30000,
      	}).then(res=>{
          if (!this.isCurrentStreamRequest(index, activeRequestId, deviceId, channelId)) {
            return;
          }
          if(res.code == 0){
          var url = res.data.https_flv.indexOf('?originTypeStr=rtp_push')!=-1?res.data.https_flv.replace('?originTypeStr=rtp_push',''):res.data.https_flv;
          camera.streamUrl = url.indexOf('39.184.153.92')!=-1?url.replace('39.184.153.92','huagongyq.dingpod.cn'):url;
            // if(OlddeviceId != this.camera.deviceId){
            //   this.closeVideo(OlddeviceId,OldchannelId);
            // }
          }
          else{
            this.$message.error(res.msg);
          }
      	})
    },
    closeVideo(OlddeviceId,OldchannelId){
      this.$axios({
      	method: 'get',
      	url: this.baseUrl+'/api/play/stop/'+OlddeviceId+'/'+OldchannelId,
      	//headers:this.headers,
      	timeout: 30000,
      	}).then(res=>{
      	})
    },
    getChannelid(deviceId,index,name){
      if(name == ""||name == null) name = "未命名设备";
      const requestId = this.nextStreamRequest(index);
      const camera = this["camera" + index];
      camera.streamUrl = "";
      camera.deviceId = deviceId;
      camera.channelId = "";
      this.$axios({
      	method: 'get',
      	// url: this.baseUrl+'/api/device/query/tree/channel/'+deviceId+'?page=1&count=1',
        url: this.baseUrl+"/api/device/query/devices/"+deviceId+"/channels?page=1&count=1",
      	timeout: 30000,
      	}).then(res=>{
          if (!this.isCurrentStreamRequest(index, requestId, deviceId)) {
            return;
          }
          var channelId = res.data.list[0].deviceId;
          camera.channelId = channelId;
          this.openVideo(deviceId,channelId,index,requestId,name);

      	})
    }
  },
  mounted() {
    this.getDeviceList(4);
    setTimeout(() => {
      if(this.mp4Path[0].deviceId != null)
      this.getChannelid(this.mp4Path[0].deviceId,0,this.mp4Path[0].name);
    }, 1000);
    setTimeout(() => {
      if(this.mp4Path[1].deviceId != null)
      this.getChannelid(this.mp4Path[1].deviceId,1,this.mp4Path[1].name);
    }, 2000);
    setTimeout(() => {
      if(this.mp4Path[2].deviceId != null)
      this.getChannelid(this.mp4Path[2].deviceId,2,this.mp4Path[2].name);
    }, 3000);
    setTimeout(() => {
      if(this.mp4Path[3].deviceId != null)
      this.getChannelid(this.mp4Path[3].deviceId,3,this.mp4Path[3].name);
    }, 4000);

    // setTimeout(() => {
    //   this.openVideo(this.mp4Path[2], 2);
    // }, 2000);
    // setTimeout(() => {
    //   this.openVideo(this.mp4Path[3], 3);
    // }, 3000);
  },
};
</script>
<style lang="scss">
.ssjk {
  .el-table,
  .el-table__expanded-cell,
  .el-table tr {
    background: #091f38 !important;
  }
  .el-table th {
    background: #115599 !important;
  }
  .el-input.el-input--suffix {
    input {
      background-color: rgb(71, 154, 175);
    }
  }
  .el-pager li:hover {
    color: #0f0;
  }
  .el-input.el-input--suffix {
    input {
      background-color: rgb(71, 154, 175);
    }
  }
  .el-table__cell {
    a {
      color: #fff !important;
    }
  }
  .el-pagination {
    button {
      background-color: transparent;
    }
  }
}
</style>
<style lang="scss" scoped>
.test-ellipsis {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}
.video-div {
  color: #fff;
  font-size: 0.2rem;
  width: 63.5%;
  > div {
    border: 1px #054b76 solid;
    padding: 5px;
    width: 50%;
    text-align: center;
    .my-video {
      border: 1px #054b76 solid;
    }
    .video-title {
      border: none;
      padding: 3px 0 5px;
      font-weight: bold;
    }
  }
}
.video-list {
  width: 36.5%;
  height: 100%;
  overflow: auto;
  background: #115599;
  overflow-y: auto;
  padding: 10px 0;
  display: flex;
  h2 {
    text-align: center;
    color: #fff;
  }
  span {
    color: #fff;
  }
  .list-real {
    flex: 2;
    border-right: 1px solid rgb(158, 158, 158);
  }
  .list-history {
    flex: 1;
    border-left: 1px solid rgb(158, 158, 158);
  }
}
.video-name-list {
  width: 100%;
  color: #fff;
  padding: 0 10px;
  cursor: pointer;
  .list-title {
    width: 100%;
    height: 0.4rem;
    font-size: 0.25rem;
    line-height: 0.4rem;
    display: inline-flex;
  }

  .video-btn {
    display: none;
    padding: 5px;
    .el-button--mini {
      font-size: 14px;
      // width:60%;
    }
    > div {
      flex: 1;
      // text-align: center;
    }
  }
  .video-btn-show {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mngm/ssjk.vue